const firedExposures = new Map<string, Set<string>>();

export function hasFiredExposure(
    experimentName: string,
    group: string
): boolean {
    return firedExposures.get(experimentName)?.has(group) ?? false;
}

export function claimExposureOncePerPage(
    experimentName: string,
    group: string
): boolean {
    const groups = firedExposures.get(experimentName) ?? new Set<string>();
    if (groups.has(group)) {
        return false;
    }
    groups.add(group);
    firedExposures.set(experimentName, groups);
    return true;
}

export function resetFiredExposures(): void {
    firedExposures.clear();
}
